import CompanyHotel from '@app/model/company_hotel/CompanyHotel';
import ProcessRequestExecutionState from '@app/model/process-request/ProcessRequestExecutionState';

class CompanyHotelMutationResult {
	companyHotel: CompanyHotel;
	rankingExecutions: ProcessRequestExecutionState[];

	constructor(data: CompanyHotelMutationResult) {
		this.companyHotel = new CompanyHotel(data.companyHotel);
		this.rankingExecutions = (data.rankingExecutions ?? [])
			.map(execution => new ProcessRequestExecutionState(execution));
	}
}

export default CompanyHotelMutationResult;
